export default "__VITE_ASSET__BAQnwheu__"